import { render, staticRenderFns } from "./RadioBlockField.vue?vue&type=template&id=45c0bf34"
import script from "./RadioBlockField.vue?vue&type=script&lang=ts"
export * from "./RadioBlockField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports